import React from 'react'
import { Box, Tabs, Tab, useTheme, alpha } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { useNavigate } from 'react-router-dom'
import { focusTab, closeTab } from '../../redux/actions/workspaceActions'

const TabManager: React.FC = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { tabs, activeTabId } = useAppSelector((state) => state.workspace)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string): void => {
    dispatch(focusTab(newValue))
    const targetTab = tabs.find((t) => t.id === newValue)
    if (targetTab) {
      navigate(targetTab.path)
    }
  }

  const handleCloseTab = (e: React.MouseEvent, tabId: string): void => {
    e.stopPropagation()
    dispatch(closeTab(tabId))
  }

  if (tabs.length === 0) return null

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        width: '100%'
      }}
    >
      <Tabs
        value={activeTabId || false}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        sx={{
          minHeight: 48,
          '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' }
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeTabId === tab.id

          return (
            <Tab
              key={tab.id}
              value={tab.id}
              label={
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: isActive ? 700 : 500,
                    py: 1
                  }}
                >
                  {tab.title}

                  {/* REPLACED IconButton WITH A CLICKABLE Box TO FIX DOM NESTING WARNING */}
                  <Box
                    onClick={(e) => handleCloseTab(e, tab.id)}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      ml: 1.5,
                      p: 0.25,
                      borderRadius: '50%',
                      cursor: 'pointer',
                      color: isActive ? 'inherit' : alpha(theme.palette.text.primary, 0.4),
                      '&:hover': {
                        bgcolor: alpha(theme.palette.error.main, 0.1),
                        color: theme.palette.error.main
                      }
                    }}
                  >
                    <CloseIcon sx={{ fontSize: '1rem' }} />
                  </Box>
                </Box>
              }
              sx={{
                textTransform: 'none',
                minHeight: 48,
                px: 2,
                bgcolor: isActive ? alpha(theme.palette.primary.main, 0.05) : 'transparent',
                transition: 'all 0.2s ease',
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.02) }
              }}
            />
          )
        })}
      </Tabs>
    </Box>
  )
}

export default TabManager
